export default "__VITE_ASSET__Dvelrbyx__"